<template>
    <form-row title="Title Company">
        <input-text
            class="flex-1"
            name="title_company"
            :value="closing.title_company"
            label="Company"
            placeholder="Company"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        closing: {},
        read_only: { default: false },
    },
}
</script>
